// extracted by mini-css-extract-plugin
export default {"loaderScreenContainer":"Suspense_loaderScreenContainer__hmSNi","loader":"Suspense_loader__qrwjI","load8":"Suspense_load8__zNF1b"};